import React, { useState } from 'react';
import './CourseBrochure.css'; // You'll need to create this CSS file
import { useParams, useNavigate } from 'react-router-dom';

const CourseBrochure = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedFaq, setExpandedFaq] = useState(null);
  const navigate = useNavigate();


  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "Do I need prior Salesforce experience?",
      answer: "No prior Salesforce experience is required. We start with fundamentals and progress to advanced topics. Basic programming knowledge is helpful but not mandatory."
    },
    {
      question: "What certifications will this prepare me for?",
      answer: "The program covers material for Salesforce Platform Developer I and II certifications, plus provides guidance for Administrator and App Builder certifications."
    },
    {
      question: "What's the course duration and time commitment?",
      answer: "The program runs for 3 months with 10-12 hours of weekly commitment including live classes, assignments, and projects."
    }
  ];

  return (
    <div className="course-brochure">
      <header className="brochure-header">
        <h1>Salesforce Platform Developer Program</h1>
        <p className="subtitle">Transform into a certified Salesforce Developer in 4 months</p>
        <div className="header-highlights">
          <div className="highlight-item">
            <span className="highlight-number">300+</span>
            <span className="highlight-label">Students Trained</span>
          </div>
          <div className="highlight-item">
            <span className="highlight-number">85%</span>
            <span className="highlight-label">Certification Pass Rate</span>
          </div>
          <div className="highlight-item">
            <span className="highlight-number">50+</span>
            <span className="highlight-label">Hiring Partners</span>
          </div>
        </div>
      </header>

      <div className="brochure-content">
        <div className="tabs">
          <button 
            className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            Overview
          </button>
          <button 
            className={`tab-btn ${activeTab === 'curriculum' ? 'active' : ''}`}
            onClick={() => setActiveTab('curriculum')}
          >
            Curriculum
          </button>
          <button 
            className={`tab-btn ${activeTab === 'outcomes' ? 'active' : ''}`}
            onClick={() => setActiveTab('outcomes')}
          >
            Career Outcomes
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'overview' && (
            <div className="overview-content">
              <h2>Program Overview</h2>
              <p>Our comprehensive Salesforce Platform Developer program is designed to transform you into a job-ready professional in 4 months.</p>
              
              <div className="program-details">
                <div className="detail-card">
                  <h3>What You'll Learn</h3>
                  <ul>
                    <li>Salesforce Fundamentals and Administration</li>
                    <li>Apex Programming and Lightning Web Components</li>
                    <li>Integration Patterns and REST/SOAP APIs</li>
                    <li>Salesforce Security Model</li>
                    <li>Testing, Debugging, and Deployment Strategies</li>
                  </ul>
                </div>

                <div className="detail-card">
                  <h3>Program Features</h3>
                  <ul>
                    <li>Live instructor-led sessions</li>
                    <li>Hands-on projects with real-world scenarios</li>
                    <li>1:1 mentorship from Salesforce experts</li>
                    <li>Career support and interview preparation</li>
                    <li>Access to Salesforce developer sandboxes</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

{activeTab === 'curriculum' && (
  <div className="curriculum-content">
    <h2>12-Week Comprehensive Curriculum</h2>
    <div className="why-choose">
      <h3>🚀 Why Choose Our Salesforce Training? 🚀</h3>
      <ul>
        <li><strong>Industry-Leading Curriculum:</strong> Designed by Salesforce veterans</li>
        <li><strong>Weekly Mock Interviews:</strong> Real-world interview practice</li>
        <li><strong>Holistic Developer Training:</strong> GitHub, Jenkins, Slack, PMD</li>
        <li><strong>Coding for Everyone:</strong> No IT background required</li>
        <li><strong>Personalized Attention:</strong> 1-on-1 mentoring and doubt resolution</li>
        <li><strong>Career Support:</strong> Resume building and job assistance</li>
      </ul>
    </div>

    <div className="week-cards">
      {/* Week 1 */}
      <div className="week-card">
        <h3>Week 1: Foundation & Setup</h3>
        <ul>
          <li>Trailhead and Trailblazer Community orientation</li>
          <li>Project management fundamentals</li>
          <li>Git and GitHub basics</li>
          <li>Agile methodology overview</li>
        </ul>
      </div>

      {/* Week 2 */}
      <div className="week-card">
        <h3>Week 2: Platform Fundamentals</h3>
        <ul>
          <li>Salesforce architecture overview</li>
          <li>Trailhead Playground setup</li>
          <li>Customer 360 platform introduction</li>
          <li>Git collaboration workflows</li>
        </ul>
      </div>

      {/* Week 3 */}
      <div className="week-card">
        <h3>Week 3: CRM Core Concepts</h3>
        <ul>
          <li>Salesforce CRM navigation</li>
          <li>Platform use cases and architecture</li>
          <li>AppExchange fundamentals</li>
        </ul>
      </div>

      {/* Week 4 */}
      <div className="week-card">
        <h3>Week 4: Data Modeling</h3>
        <ul>
          <li>Custom/standard objects and relationships</li>
          <li>Schema Builder practicals</li>
          <li>Account/Contact data management</li>
          <li>Lightning Experience customization</li>
        </ul>
      </div>

      {/* Week 5 */}
      <div className="week-card">
        <h3>Week 5: Web Basics & Apex Intro</h3>
        <ul>
          <li>HTML/CSS/JavaScript fundamentals</li>
          <li>Apex programming basics</li>
          <li>SOQL/SOSL introduction</li>
          <li>Advanced data types and validation</li>
        </ul>
      </div>

      {/* Week 6 */}
      <div className="week-card">
        <h3>Week 6: Security & Web Projects</h3>
        <ul>
          <li>User access control</li>
          <li>Role hierarchies and sharing rules</li>
          <li>HTML/CSS/JavaScript projects</li>
          <li>Apex triggers introduction</li>
        </ul>
      </div>

      {/* Week 7 */}
      <div className="week-card">
        <h3>Week 7: Automation & Advanced JS</h3>
        <ul>
          <li>Flow Builder fundamentals</li>
          <li>Flow variables and logic</li>
          <li>Advanced JavaScript (ES6, async)</li>
        </ul>
      </div>

      {/* Week 8 */}
      <div className="week-card">
        <h3>Week 8: Advanced Automation</h3>
        <ul>
          <li>Complex flow building</li>
          <li>Approval processes</li>
          <li>Apex DML and queries</li>
          <li>Integration basics (REST/SOAP)</li>
        </ul>
      </div>

      {/* Week 9 */}
      <div className="week-card">
        <h3>Week 9: LWC & Async Apex</h3>
        <ul>
          <li>Lightning Web Components basics</li>
          <li>LWC event handling</li>
          <li>Async Apex processing</li>
          <li>Batch and Queueable Apex</li>
        </ul>
      </div>

      {/* Week 10 */}
      <div className="week-card">
        <h3>Week 10: Advanced LWC</h3>
        <ul>
          <li>LWC data handling</li>
          <li>Jest testing framework</li>
          <li>Accessibility standards</li>
          <li>Component communication</li>
        </ul>
      </div>

      {/* Week 11 */}
      <div className="week-card">
        <h3>Week 11: DevOps & Projects</h3>
        <ul>
          <li>PMD static analysis</li>
          <li>GitHub/Jenkins deployments</li>
          <li>Mini projects (Flows, Apex, LWC)</li>
        </ul>
      </div>

      {/* Week 12 */}
      <div className="week-card">
        <h3>Week 12: Capstone & Certification</h3>
        <ul>
          <li>Major project development</li>
          <li>Superbadge completion</li>
          <li>Flow optimization techniques</li>
          <li>Certification preparation</li>
        </ul>
      </div>
    </div>

    <div className="tech-stack">
      <h3>💼 Comprehensive Technology Coverage 💼</h3>
      <div className="tech-grid">
        <div className="tech-category">
          <h4>Core Salesforce</h4>
          <ul>
            <li>Apex</li>
            <li>SOQL/SOSL</li>
            <li>Lightning Web Components</li>
            <li>Flow Builder</li>
          </ul>
        </div>
        <div className="tech-category">
          <h4>Web Fundamentals</h4>
          <ul>
            <li>HTML/CSS</li>
            <li>JavaScript (ES6+)</li>
            <li>Web Accessibility</li>
          </ul>
        </div>
        <div className="tech-category">
          <h4>DevOps Tools</h4>
          <ul>
            <li>Git/GitHub</li>
            <li>Jenkins</li>
            <li>PMD</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)}

          {activeTab === 'outcomes' && (
            <div className="outcomes-content">
              <h2>Career Outcomes</h2>
              
              <div className="outcome-stats">
                <div className="stat-card">
                  <h3>Average Salary Increase</h3>
                  <p className="stat-value">65%</p>
                  <p>for graduates transitioning to developer roles</p>
                </div>
                
                <div className="stat-card">
                  <h3>Certification Success</h3>
                  <p className="stat-value">92%</p>
                  <p>first-time pass rate for Platform Developer I</p>
                </div>
              </div>

              <h3>Job Roles You Can Pursue</h3>
              <ul className="job-roles">
                <li>Salesforce Developer</li>
                <li>Salesforce Technical Consultant</li>
                <li>Lightning Web Component Developer</li>
                <li>Salesforce Integration Specialist</li>
              </ul>

              <div className="testimonial">
                <blockquote>
                  "The CodeXLNC program gave me the skills to transition from IT support to a Salesforce Developer role with a 70% salary increase in just 8 months."
                </blockquote>
                <p className="testimonial-author">- Avinash., Salesforce Developer at MNC</p>
              </div>
            </div>
          )}
        </div>

        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`} key={index}>
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  {faq.question}
                  <span className="toggle-icon">{expandedFaq === index ? '-' : '+'}</span>
                </button>
                {expandedFaq === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="cta-section">
          <h2>Ready to Start Your Salesforce Developer Journey?</h2>
          <p>Next cohort begins: July 15, 2025</p>
          <button onClick={() => navigate('/enroll')} className="enroll-btn">Enroll Now</button>
        
          <p className="payment-options">Flexible payment plans available including monthly installments and ISA options</p>
        </div>
      </div>
    </div>
  );
};

export default CourseBrochure;